(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_header-drawer-menu"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    var panelsWrapper = document.querySelector('[data-ref="mobile-menu-panels"]');
    if (!panelsWrapper) return;

    function getActivePanel() {
      return panelsWrapper.querySelector('.header__mobile-menu-panel.is-active');
    }

    function goToPanel(target, direction) {
      var current = getActivePanel();
      if (!target || target === current) return;

      current.classList.remove('is-active');
      current.classList.add(direction === 'forward' ? 'is-exiting-left' : 'is-exiting-right');

      target.classList.remove('is-exiting-left', 'is-exiting-right');
      // Force le point de départ avant transition
      target.style.transition = 'none';
      target.style.transform = direction === 'forward' ? 'translateX(100%)' : 'translateX(-100%)';
      target.getBoundingClientRect();
      target.style.transition = '';
      target.style.transform = '';
      target.classList.add('is-active');

      var cleanup = function () {
        current.classList.remove('is-exiting-left', 'is-exiting-right');
        target.removeEventListener('transitionend', cleanup);
      };
      target.addEventListener('transitionend', cleanup);
    }

    panelsWrapper.addEventListener('click', function (event) {
      var openTrigger = event.target.closest('[data-ref="mobile-menu-open-panel"]');
      if (openTrigger) {
        var targetId = openTrigger.getAttribute('data-panel-target');
        var target = document.getElementById(targetId);
        goToPanel(target, 'forward');
        return;
      }

      var backTrigger = event.target.closest('[data-ref="mobile-menu-back"]');
      if (backTrigger) {
        var parentPanel = panelsWrapper.querySelector('.header__mobile-menu-panel[data-level="0"]');
        var current = getActivePanel();
        var target = parentPanel;

        if (current && current.getAttribute('data-level') === '2') {
          var currentId = current.id;
          var parentId = currentId.replace(/-\d+$/, '');
          var candidate = document.getElementById(parentId);
          if (candidate) target = candidate;
        }

        goToPanel(target, 'back');
      }
    });

    // Réinitialise sur le premier panneau à chaque ouverture du menu
    var menuOverlay = document.querySelector('[data-ref="mobile-menu-overlay"]');
    if (menuOverlay) {
      var observer = new MutationObserver(function () {
        if (menuOverlay.classList.contains('is-open')) {
          var basePanel = panelsWrapper.querySelector('.header__mobile-menu-panel[data-level="0"]');
          var current = getActivePanel();
          if (current && current !== basePanel) {
            current.classList.remove('is-active', 'is-exiting-left', 'is-exiting-right');
            basePanel.classList.add('is-active');
          }
        }
      });
      observer.observe(menuOverlay, { attributes: true, attributeFilter: ['class'] });
    }
  });
  } catch(e) { console.error(e); }
})();

})();
